/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogService } from "primeng/dynamicdialog";
import { MenuModule } from "primeng/menu";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";
import { TagModule } from "primeng/tag";
import { TooltipModule } from "primeng/tooltip";
import { ProgressBarModule } from "primeng/progressbar";
import { PopoverModule } from "primeng/popover";
import { ToastModule } from "primeng/toast";
import { firstValueFrom, of, Subject } from "rxjs";
import { catchError, switchMap, takeUntil, tap } from "rxjs/operators";
import { ScheduledOrder } from "../../../../core/models/scheduled-order.interface";
import { ScheduledOrderItem } from "../../../../core/models/scheduled-order-item.interface";
import { ScheduledOrderCoupon } from "../../../../core/models/scheduled-order-coupon.interface";
import { ScheduledOrderShippingRateOption } from "../../../../core/models/scheduled-order-shipping-rate-option.interface";
import { Site } from "../../../../core/models/site.interface";
import {
  QPilotCustomer,
  QPilotPaymentMethod,
  QPilotShippingAddress,
} from "../../../../core/models/qpilot";
import {
  QPilotService,
  QPilotAccessToken,
  QPilotUser,
} from "../../../../core/services/qpilot.service";
import { SessionService } from "../../../../core/services/session.service";
import { NextimeService } from "../../../../core/services/nextime.service";
import { NextimeSite } from "../../../../core/models/nextime-site.interface";
import {
  NextimeShippingLinesData,
  NextimeDeliveryDate,
  NextimeShippingLine,
} from "../../../../core/models/nextime-response.interface";
import { NextimeRequestPayload } from "../../../../core/models/nextime-request.interface";
import { TimezoneHelper } from "../../../../core/utils/timezone.helper";
import { ScheduledOrderCyclesDialogComponent } from "../../components/scheduled-order-cycles-dialog/scheduled-order-cycles-dialog.component";
import { ScheduledOrderHistoryDialogComponent } from "../../components/scheduled-order-history-dialog/scheduled-order-history-dialog.component";
import { ProcessingCycleLogsDialogComponent } from "../../components/processing-cycle-logs-dialog/processing-cycle-logs-dialog.component";
import { ValidationChecksDialogComponent } from "../../components/validation-checks-dialog/validation-checks-dialog.component";
import { RescheduleDialogComponent } from "../../components/reschedule-dialog/reschedule-dialog.component";
import { RescheduleDialogResult } from "../../interfaces/reschedule-dialog-data.interface";
import { ScheduledOrderFormComponent } from "../../components/shared/scheduled-order-form/scheduled-order-form.component";
import { ScheduledOrderQuickActionsComponent } from "../../components/scheduled-order-quick-actions/scheduled-order-quick-actions.component";
import { TotalsDisplayComponent } from "../../components/shared/totals-display/totals-display.component";
import { ScheduledOrderLiveDataService } from "../../services/scheduled-order-live-data.service";
import { ScheduledOrderProcessingService } from "../../services/scheduled-order-processing.service";
import { ScheduledOrderValidationService } from "../../services/scheduled-order-validation.service";
import { ScheduledOrderService } from "../../services/scheduled-order.service";
import {
  ScheduledOrderForm,
  ScheduledOrderItemForm,
} from "../../interfaces/scheduled-order-form.interface";

/**
 * Page component for editing existing scheduled orders
 * Loads order by ID, enables editing, and handles update workflow
 * Includes live status updates and validation
 */
@Component({
  selector: "app-edit-scheduled-order",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    ProgressSpinnerModule,
    CardModule,
    ConfirmDialogModule,
    TagModule,
    SkeletonModule,
    MenuModule,
    TooltipModule,
    PopoverModule,
    ScheduledOrderFormComponent,
    ProgressBarModule,
    ScheduledOrderQuickActionsComponent,
    TotalsDisplayComponent,
    ToastModule,
  ],
  providers: [ConfirmationService, DialogService],
  // Note: MessageService is NOT provided locally - we use the root instance
  // This ensures both component toast calls AND API interceptor error toasts
  // go to the same MessageService that the <p-toast> listens to
  templateUrl: "./edit-scheduled-order.component.html",
  styleUrl: "./edit-scheduled-order.component.scss",
})
export class EditScheduledOrderComponent implements OnInit, OnDestroy {
  // Dual mode inputs for web component/iframe support
  @Input() inputSiteId?: number;
  @Input() inputToken?: QPilotAccessToken;
  @Input() inputOrderId?: number; // Required for edit mode
  @Input() embeddedMode: boolean = false;
  @Input() hideToolbar: boolean = false;

  siteId!: number;
  scheduledOrderId!: number;
  site?: Site;
  scheduledOrder?: ScheduledOrder;
  formGroup!: FormGroup<ScheduledOrderForm>;
  isLoading = false;
  isSaving = false;
  isProcessing = false;

  // Edit-specific state
  hasNextime = false;
  showValidationIndicator = false;
  showQuickActions = true; // Toggle for quick actions visibility (mobile)

  // Nextime state (matches old QMC lines 232-234, 337-341)
  nextimeSiteId: string | null = null;
  nextimeSiteToken: string | null = null;
  nextimeShouldDisplayDeliveryDate = true;
  nextimeShouldAlignNextOrderDate = true;
  nextimeSite: NextimeSite | null = null;
  nextimeShippingOptions: NextimeShippingLinesData | null = null;

  // Subscription tier permissions (matches old QMC lines 117-119)
  advancedOptionsAllowed: boolean = true;
  tierName: string = "";
  upgradeUrl: string = "";

  // Track selected shipping tab for address logic (matches old QMC line 56)
  selectedCustomerShippingTabIndex = 0;

  // New payment method for creation (matches old QMC line 52)
  newPaymentMethod: QPilotPaymentMethod = {} as QPilotPaymentMethod;

  // Action menu items
  actionMenuItems: MenuItem[] = [];

  // ViewChild reference to form component for accessing totals observer
  // Matches old QMC line 141: @ViewChild(DashboardScheduledOrdersTotalsComponent)
  @ViewChild(ScheduledOrderFormComponent)
  formComponent!: ScheduledOrderFormComponent;

  private destroy$ = new Subject<void>();

  constructor(
    private readonly elementRef: ElementRef, // Required for attribute access in web component mode
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private scheduledOrderService: ScheduledOrderService,
    private validationService: ScheduledOrderValidationService,
    private processingService: ScheduledOrderProcessingService,
    private liveDataService: ScheduledOrderLiveDataService,
    private qpilotService: QPilotService,
    private sessionService: SessionService,
    private nextimeService: NextimeService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private timezoneHelper: TimezoneHelper,
  ) {}

  ngOnInit(): void {
    const element = this.elementRef.nativeElement as HTMLElement;

    // Check if embedded mode is set via input or attribute (for web components)
    const embeddedModeAttr =
      element.getAttribute("embedded-mode") ??
      element.getAttribute("embeddedMode");
    if (embeddedModeAttr === "true" || embeddedModeAttr === "") {
      this.embeddedMode = true;
    }

    // Handle dual mode initialization
    if (this.embeddedMode) {
      // Embedded mode: Get siteId and orderId from input/attribute
      const siteIdString =
        this.inputSiteId?.toString() ??
        element.getAttribute("input-site-id") ??
        element.getAttribute("inputSiteId");

      if (siteIdString) {
        this.siteId = parseInt(siteIdString, 10);
      }

      // Get token from attribute and convert to QPilotAccessToken
      const tokenString =
        element.getAttribute("input-token") ??
        element.getAttribute("inputToken");

      // Create inputToken from attribute if:
      // 1. We have a token string from attribute
      // 2. AND inputToken is either missing, not an object, or doesn't have valid TokenBearerAuth
      // Note: Angular Elements may bind the attribute as a raw string, so we check for proper structure
      if (
        tokenString &&
        (!this.inputToken ||
          typeof this.inputToken !== "object" ||
          !this.inputToken.TokenBearerAuth)
      ) {
        this.inputToken = {
          TokenBearerAuth: tokenString,
          TokenAuth: "",
          Id: 0,
          UserId: 0,
          CreatedUtc: new Date(),
          UpdatedUtc: new Date(),
          ExpiresUtc: new Date(),
          User: {} as QPilotUser,
          FirstLogin: 0,
        };
      }

      // Get order ID (required for edit mode)
      const orderIdString =
        this.inputOrderId?.toString() ??
        element.getAttribute("input-order-id") ??
        element.getAttribute("inputOrderId");

      if (orderIdString) {
        this.scheduledOrderId = parseInt(orderIdString, 10);
      }

      // Load order for embedded mode
      void this.loadScheduledOrder();
    } else {
      // Standard mode: Extract siteId and scheduledOrderId from route params
      // Route pattern: /widgets/dashboard/:siteId/scheduled-orders/:id/edit
      // siteId is in parent route params, id is in current route params
      this.route.parent?.params
        .pipe(takeUntil(this.destroy$))
        .subscribe((parentParams) => {
          this.siteId = +parentParams["siteId"];

          this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe((params) => {
              this.scheduledOrderId = +params["id"];
              this.loadScheduledOrder();
            });
        });
    }
  }

  /**
   * Get access token based on mode (embedded vs standard)
   */
  getAccessToken(): QPilotAccessToken | undefined {
    if (this.embeddedMode && this.inputToken) {
      return this.inputToken;
    }
    // Use null coalescing to convert null to undefined for type consistency
    return this.sessionService.accessToken ?? undefined;
  }

  /**
   * Load scheduled order and site data
   */
  private async loadScheduledOrder(): Promise<void> {
    this.isLoading = true;

    try {
      const accessToken = this.getAccessToken();

      if (!accessToken) {
        this.messageService.add({
          severity: "error",
          summary: "Authentication Error",
          detail: "Unable to load scheduled order. Invalid token.",
        });
        // Only redirect to login in standard mode
        if (!this.embeddedMode) {
          this.router.navigate(["/auth/login"]);
        }
        return;
      }

      // Load order, site, and subscription tier permissions in parallel
      // Nextime check must run AFTER order is loaded (matches old QMC lines 227-250)
      const [order, siteFull, _tierPermissions] = await Promise.all([
        firstValueFrom(
          this.scheduledOrderService.getById(
            this.scheduledOrderId,
            accessToken,
          ),
        ),
        firstValueFrom(
          this.qpilotService.getSiteFull(this.siteId, accessToken),
        ),
        this.loadSubscriptionTierPermissions(), // Task 3.3: Load tier permissions (matches old QMC lines 377-388)
      ]);

      this.scheduledOrder = order;
      // Convert SiteFull to Site interface (they're compatible)
      this.site = siteFull as unknown as Site;

      // Initialize and populate form group
      this.initializeFormGroup();
      this.populateFormGroup(order);

      // Check Nextime AFTER order is loaded (matches old QMC line 227)
      // This is critical because getNextimeShippingOptions needs this.scheduledOrder
      await this.checkNextime();

      // Initialize validation indicator and fetch validation if needed
      if (order.ValidationResult) {
        this.showValidationIndicator = true;
      } else {
        // Fetch validation result if not returned by API
        await this.refreshValidation();
      }

      // Build action menu based on order state
      this.buildActionMenu();

      // Live status updates disabled to reduce API load
      // this.subscribeToLiveUpdates();
    } catch (error: unknown) {
      console.error("Error loading scheduled order:", error);
      this.messageService.add({
        severity: "error",
        summary: "Load Failed",
        detail: "Failed to load scheduled order. Please try again.",
      });
      // Navigate back to list (standard mode only - embedded mode shouldn't auto-navigate on error)
      if (!this.embeddedMode) {
        this.router.navigate([
          "/widgets",
          "dashboard",
          this.siteId,
          "scheduled-orders",
        ]);
      }
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Check if Nextime integration is enabled for this site
   * Matches old QMC lines 228-250
   * @returns Promise resolving to Nextime settings or null
   */
  private async checkNextime(): Promise<any> {
    try {
      const accessToken = this.getAccessToken();
      if (!accessToken) {
        return null;
      }

      const response = await firstValueFrom(
        this.qpilotService.getNextimeSiteIdIfExists(this.siteId, accessToken),
      );

      if (response && response.SiteId) {
        // Store Nextime configuration (matches old QMC lines 232-234)
        this.hasNextime = response.IsEnabled;
        this.nextimeSiteId = response.SiteId;
        this.nextimeSiteToken = response.SiteToken;

        if (response.IsEnabled) {
          // If enabled, fetch site settings first (matches old QMC line 237)
          await this.fetchNextimeSiteSettings(
            response.SiteId,
            response.SiteToken,
          );
        } else {
          // If not enabled, just fetch shipping options (matches old QMC line 239)
          await this.getNextimeShippingOptions(
            response.SiteId,
            response.SiteToken,
          );
        }
      } else {
        this.hasNextime = false;
      }

      return response;
    } catch (error: unknown) {
      console.error("Nextime check error:", error);
      this.hasNextime = false;
      return null;
    }
  }

  /**
   * Build Nextime shipping option request payload
   * Matches old QMC lines 269-295
   * @returns Nextime request payload
   */
  private getNextimeShippingOptionRequest(): NextimeRequestPayload {
    if (!this.scheduledOrder) {
      throw new Error("Scheduled order not loaded");
    }

    return {
      orderId: this.scheduledOrder.Id?.toString() || "0",
      items: (this.scheduledOrder.ScheduledOrderItems || []).map((item) => {
        const product = item.Product;
        const hasWeight = product?.Weight && product.Weight > 0;
        const hasDimensions =
          (product?.Length && product.Length > 0) ||
          (product?.Width && product.Width > 0) ||
          (product?.Height && product.Height > 0);

        return {
          id: item.Id || 0,
          productId: item.ProductId?.toString() || "0",
          qty: item.Quantity || 0,
          regularPrice: item.Price || 0,
          salePrice: item.SalePrice || 0,
          weight: product?.Weight || undefined,
          WeightUnitType: product?.WeightUnitType
            ? this.convertWeightUnit(product.WeightUnitType)
            : undefined,
          length: product?.Length || undefined,
          width: product?.Width || undefined,
          height: product?.Height || undefined,
          LengthUnitType: product?.LengthUnitType
            ? this.convertLengthUnit(product.LengthUnitType)
            : undefined,
          IsPhysical: !!(hasWeight || hasDimensions),
        };
      }),
      shippingAddress: {
        country: this.scheduledOrder.ShippingCountry || "",
        city: this.scheduledOrder.ShippingCity || "",
        postalCode: this.scheduledOrder.ShippingPostcode || "",
        state: this.scheduledOrder.ShippingState || "",
        street: this.scheduledOrder.ShippingStreet1 || "",
      },
      shippingOptionFilters: {
        nextOrderDate: this.scheduledOrder.NextOccurrenceUtc || undefined,
        includeProducts: true,
        preferredShippingRate:
          this.scheduledOrder.PreferredShippingRateOption || undefined,
      },
    };
  }

  /**
   * Convert weight unit string to Nextime weight unit type enum value
   * @param unitType Weight unit type string (e.g., 'Pound', 'Kilogram')
   * @returns Numeric enum value for Nextime API
   */
  private convertWeightUnit(unitType: string): number {
    const mapping: Record<string, number> = {
      Pound: 1,
      Ounce: 2,
      Kilogram: 3,
      Gram: 4,
    };
    return mapping[unitType] || 0;
  }

  /**
   * Convert length unit string to Nextime length unit type enum value
   * @param unitType Length unit type string (e.g., 'In', 'Cm')
   * @returns Numeric enum value for Nextime API
   */
  private convertLengthUnit(unitType: string): number {
    const mapping: Record<string, number> = {
      In: 1,
      in: 1,
      Ft: 2,
      ft: 2,
      Yd: 3,
      yd: 3,
      Mm: 4,
      mm: 4,
      Cm: 5,
      cm: 5,
      M: 6,
      m: 6,
    };
    return mapping[unitType] || 0;
  }

  /**
   * Fetch Nextime site settings (feature flags)
   * Matches old QMC lines 297-313
   * @param siteId Nextime site ID
   * @param apiKey Nextime API key
   */
  private async fetchNextimeSiteSettings(
    siteId: string,
    apiKey: string,
  ): Promise<void> {
    try {
      const nextimeSite = await firstValueFrom(
        this.nextimeService.getSite(parseInt(siteId)),
      );

      this.nextimeSite = nextimeSite;
      this.nextimeShouldDisplayDeliveryDate =
        nextimeSite.shouldDisplayDeliveryDate;
      this.nextimeShouldAlignNextOrderDate =
        nextimeSite.shouldAlignNextOrderDate;

      // After fetching settings, fetch shipping options (matches old QMC line 304)
      await this.getNextimeShippingOptions(siteId, apiKey);
    } catch (error: unknown) {
      console.error("Error fetching Nextime site settings:", error);
      // Use defaults on error (matches old QMC lines 308-309)
      this.nextimeShouldDisplayDeliveryDate = true;
      this.nextimeShouldAlignNextOrderDate = true;
      // Still try to fetch shipping options (matches old QMC line 310)
      await this.getNextimeShippingOptions(siteId, apiKey);
    }
  }

  /**
   * Fetch Nextime shipping options and delivery dates
   * Matches old QMC lines 329-358
   * @param siteId Nextime site ID
   * @param apiKey Nextime API key
   */
  private async getNextimeShippingOptions(
    siteId: string,
    apiKey: string,
  ): Promise<void> {
    try {
      // Only make API call if Nextime is enabled (matches old QMC line 332)
      if (!this.hasNextime) {
        this.nextimeShippingOptions = {
          deliveryDates: [],
          errors: [],
          recommendedDeliveryDate: undefined as unknown as NextimeDeliveryDate,
        };
        return;
      }

      const payload = this.getNextimeShippingOptionRequest();

      const response = await firstValueFrom(
        this.nextimeService.getShippingOptions(siteId, apiKey, payload),
      );

      this.nextimeShippingOptions =
        response.shippingLines || ({} as NextimeShippingLinesData);
      this.hasNextime = response.succeeded || false;

      // Convert Nextime delivery dates to QPilot shipping options (matches old QMC line 344)
      if (
        this.nextimeShippingOptions.deliveryDates &&
        this.nextimeShippingOptions.deliveryDates.length > 0 &&
        this.scheduledOrder
      ) {
        if (this.nextimeShouldDisplayDeliveryDate) {
          // Replace shipping options with Nextime-converted options (matches old QMC line 344)
          this.scheduledOrder.ShippingRateOptions =
            this.nextimeService.convertToQPilotOptions(
              this.nextimeShippingOptions.deliveryDates,
              this.scheduledOrder.PreferredShippingRateOption,
            );
        }
      }

      // Note: The form component will auto-select the first delivery date
      // via the nextimeShippingOptions @Input setter
    } catch (error: unknown) {
      console.error("Error fetching Nextime shipping options:", error);
      // Keep Nextime UI visible with empty data (matches old QMC behavior)
      this.nextimeShippingOptions = {
        deliveryDates: [],
        errors: [],
        recommendedDeliveryDate: undefined as unknown as NextimeDeliveryDate,
      };
    }
  }

  /**
   * Initialize the reactive form group
   * Creates empty form structure - will be populated after loading order
   */
  private initializeFormGroup(): void {
    this.formGroup = this.formBuilder.nonNullable.group({
      // Customer
      customerId: [null as number | null],
      customer: [null as QPilotCustomer | null],

      // Products
      scheduledOrderItems: this.formBuilder.nonNullable.array<
        FormGroup<ScheduledOrderItemForm>
      >([]),

      // Coupons
      coupons: [""],
      couponsHistory: [[] as ScheduledOrderCoupon[]],

      // Frequency
      frequencyType: ["Months"],
      frequency: [1],
      cycles: [0],
      nextOccurrenceUtc: [null as Date | null, [Validators.required]],

      // Shipping Address
      shippingFirstName: [""],
      shippingLastName: [""],
      shippingStreet1: [""],
      shippingStreet2: [""],
      shippingCity: [""],
      shippingState: [""],
      shippingPostcode: [""],
      shippingCountry: [""],
      preferredShippingRateOption: [null as string | null],
      enableAutoShippingRate: [false],
      siteShippingAddressId: [null as number | null],
      siteShippingAddress: [null as QPilotShippingAddress | null],

      // Payment
      paymentMethodId: [null as number | null],
      paymentMethod: [null as QPilotPaymentMethod | null],

      // Advanced Options
      name: [""],
      note: [""],
      nextOccurrenceOffset: [0],
      nextOccurrenceTime: [null as string | null],
      customerTimezone: [null as number | null],

      // Settings
      currencyIso: ["USD"],
      utcOffset: [0],
      status: ["Paused"],
      displaySalePrice: [false],
    });
  }

  /**
   * Create a properly typed FormGroup for a scheduled order item
   * Ensures compatibility with ItemManagerComponent expectations
   * Must match the EXACT structure used by ItemManagerComponent's createItemFormGroup
   * @param item Optional item to populate form with existing values
   * @returns Typed FormGroup for the item
   */
  private createItemFormGroup(
    item?: ScheduledOrderItem,
  ): FormGroup<ScheduledOrderItemForm> {
    // CRITICAL: Use formBuilder.nonNullable.group with explicit structure
    // This matches ItemManagerComponent.createItemFormGroup() exactly (line 79-90)
    // IMPORTANT: Include all fields from old QMC payload for API compatibility
    return this.formBuilder.nonNullable.group({
      id: [item?.Id ?? null],
      scheduledOrderId: [item?.ScheduledOrderId ?? null],
      productId: [item?.ProductId || 0],
      quantity: [item?.Quantity || 1],
      price: [item?.Price || 0],
      salePrice: [item?.SalePrice ?? undefined],
      originalSalePrice: [item?.OriginalSalePrice ?? null],
      product: [item?.Product ?? null],
      disabled: [item?.Disabled ?? false],
      cycles: [item?.Cycles ?? 0],
      minCycles: [item?.MinCycles ?? null],
      maxCycles: [item?.MaxCycles ?? null],
      createdUtc: [
        item?.CreatedUtc ? new Date(item.CreatedUtc).toISOString() : null,
      ],
      updatedUtc: [
        item?.UpdatedUtc ? new Date(item.UpdatedUtc).toISOString() : null,
      ],
      metadata: [item?.Metadata ?? null],
    }) as unknown as FormGroup<ScheduledOrderItemForm>;
  }

  /**
   * Populate form group with loaded order data
   * @param order The scheduled order loaded from API
   */
  private populateFormGroup(order: ScheduledOrder): void {
    // Patch primitive values
    this.formGroup.patchValue({
      customerId: order.CustomerId,
      customer: order.Customer,
      coupons: order.Coupons || "",
      couponsHistory: order.CouponsHistory || [],
      frequencyType: order.FrequencyType,
      frequency: order.Frequency,
      cycles: order.Cycles || 0,
      nextOccurrenceUtc: order.NextOccurrenceUtc
        ? new Date(order.NextOccurrenceUtc)
        : null,
      shippingFirstName: order.ShippingFirstName || "",
      shippingLastName: order.ShippingLastName || "",
      shippingStreet1: order.ShippingStreet1 || "",
      shippingStreet2: order.ShippingStreet2 || "",
      shippingCity: order.ShippingCity || "",
      shippingState: order.ShippingState || "",
      shippingPostcode: order.ShippingPostcode || "",
      shippingCountry: order.ShippingCountry || "",
      preferredShippingRateOption: order.PreferredShippingRateOption || null,
      enableAutoShippingRate: order.EnableAutoShippingRate ?? false,
      paymentMethodId: order.PaymentMethodId || null,
      paymentMethod: order.PaymentMethod || null,
      name: order.Name || "",
      note: order.Note || "",
      nextOccurrenceOffset: order.NextOccurrenceOffset || 0,
      currencyIso: order.CurrencyIso || "USD",
      utcOffset: order.UtcOffset || 0,
      status: order.Status,
      displaySalePrice: order.DisplaySalePrice || false,
    });

    // Populate items array using properly typed FormGroups
    const itemsArray = this.formGroup.controls.scheduledOrderItems;
    itemsArray.clear();
    if (order.ScheduledOrderItems && order.ScheduledOrderItems.length > 0) {
      order.ScheduledOrderItems.forEach((item) => {
        itemsArray.push(this.createItemFormGroup(item));
      });
    }
  }

  /**
   * Load subscription tier permissions and site tier information
   * Matches old QMC lines 377-388
   * Calls both permissions and tier info in parallel
   */
  private async loadSubscriptionTierPermissions(): Promise<void> {
    try {
      const accessToken = this.getAccessToken();
      if (!accessToken) return;

      // Call both APIs in parallel (they're independent)
      await Promise.all([
        this.getSubscriptionTierPermissions(),
        this.getSiteSubscriptionTier(),
      ]);
    } catch (error: unknown) {
      console.error("Subscription tier load error:", error);
      // Fail silently - default to allowing features
      this.advancedOptionsAllowed = true;
    }
  }

  /**
   * Check if advanced options are allowed for current subscription tier
   * Matches old QMC lines 377-382
   */
  private async getSubscriptionTierPermissions(): Promise<void> {
    try {
      const accessToken = this.getAccessToken();
      if (!accessToken) return;

      // Get current page path for permission check
      // OLD QMC uses getPage(router, 3) which extracts 'scheduled-orders' from URL
      // URL: /widgets/dashboard/1781/scheduled-orders/160022/edit
      // Index 3 from end = 'scheduled-orders'
      const page = "scheduled-orders";

      const pageData = await firstValueFrom(
        this.qpilotService.getPageByUrl(
          page,
          this.siteId.toString(),
          accessToken,
        ),
      );

      this.advancedOptionsAllowed = pageData?.allowedForSubscription ?? true;
    } catch (error: unknown) {
      console.error("Permission check error:", error);
      // Default to allowing features on error
      this.advancedOptionsAllowed = true;
    }
  }

  /**
   * Get site subscription tier information
   * Matches old QMC lines 384-388
   */
  private async getSiteSubscriptionTier(): Promise<void> {
    try {
      const accessToken = this.getAccessToken();
      if (!accessToken) return;

      const siteTier = await firstValueFrom(
        this.qpilotService.fetchSiteSubscriptionTier(
          accessToken,
          this.siteId.toString(),
        ),
      );

      this.tierName = `${siteTier.TierName} Plan`;
      this.upgradeUrl = "/my-account/subscription/change-plan";
    } catch (error: unknown) {
      console.error("Site tier fetch error:", error);
      // Default values on error
      this.tierName = "";
      this.upgradeUrl = "";
    }
  }

  /**
   * Subscribe to live data updates for this order
   * Only polls when order is in active processing states (Processing, Queued)
   * to avoid unnecessary API calls
   */
  private subscribeToLiveUpdates(): void {
    // Only enable live polling for orders that are actively processing
    const status = this.scheduledOrder?.Status;
    const shouldPoll = status === "Processing" || status === "Queued";

    if (!shouldPoll) {
      // Don't poll for stable states (Active, Paused, Failed, etc.)
      return;
    }

    this.liveDataService
      .subscribe(this.siteId, this.scheduledOrderId, this.getAccessToken())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (updatedOrder) => this.handleLiveUpdate(updatedOrder),
        error: (error) => console.error("Live update error:", error),
      });
  }

  /**
   * Handle live data updates from polling
   * @param updatedOrder Updated order from API
   */
  private handleLiveUpdate(updatedOrder: ScheduledOrder): void {
    if (this.scheduledOrder && updatedOrder) {
      const statusChanged = this.scheduledOrder.Status !== updatedOrder.Status;

      // Update local copy
      this.scheduledOrder = { ...this.scheduledOrder, ...updatedOrder };

      // Show notification if status changed
      if (statusChanged) {
        this.messageService.add({
          severity: "info",
          summary: "Status Updated",
          detail: `Order status changed to ${updatedOrder.Status}`,
          life: 3000,
        });
      }
    }
  }

  /**
   * Apply form values to scheduledOrder object
   * Updates scheduledOrder directly from form (matches old QMC pattern of direct property modification)
   * IMPORTANT: Use getRawValue() to include disabled controls (customer is disabled in edit mode)
   */
  private applyFormValuesToOrder(): void {
    if (!this.scheduledOrder) return;

    // Use getRawValue() to include disabled controls (customer control is disabled in edit mode)
    const formValues = this.formGroup.getRawValue();

    // Apply all form values to scheduledOrder (preserves properties not in form)
    this.scheduledOrder.CustomerId = formValues.customerId!;
    this.scheduledOrder.Customer = formValues.customer!;
    this.scheduledOrder.FrequencyType = formValues.frequencyType!;
    this.scheduledOrder.Frequency = formValues.frequency!;
    this.scheduledOrder.Cycles = formValues.cycles!;
    this.scheduledOrder.NextOccurrenceUtc = formValues.nextOccurrenceUtc as any;
    this.scheduledOrder.Status = formValues.status!;

    // Map form items to API items (matches old QMC - ensures Price and SalePrice are included)
    this.scheduledOrder.ScheduledOrderItems = (
      formValues.scheduledOrderItems || []
    ).map((formItem: any) => ({
      Id: formItem.id,
      ProductId: formItem.productId,
      Product: formItem.product,
      Quantity: formItem.quantity,
      Price: formItem.price, // API requires Price field
      SalePrice: formItem.salePrice, // API requires SalePrice field
      OriginalSalePrice: formItem.salePrice, // Required for discount calculation
      Cycles: formItem.cycles ?? 0, // API requires integer, not null
      MinCycles: formItem.minCycles, // API accepts null
      MaxCycles: formItem.maxCycles, // API accepts null
    }));
    this.scheduledOrder.Coupons = formValues.coupons || "";
    this.scheduledOrder.CouponsHistory = formValues.couponsHistory || [];
    this.scheduledOrder.ShippingFirstName = formValues.shippingFirstName!;
    this.scheduledOrder.ShippingLastName = formValues.shippingLastName!;
    this.scheduledOrder.ShippingStreet1 = formValues.shippingStreet1!;
    this.scheduledOrder.ShippingStreet2 = formValues.shippingStreet2!;
    this.scheduledOrder.ShippingCity = formValues.shippingCity!;
    this.scheduledOrder.ShippingState = formValues.shippingState!;
    this.scheduledOrder.ShippingPostcode = formValues.shippingPostcode!;
    this.scheduledOrder.ShippingCountry = formValues.shippingCountry!;
    this.scheduledOrder.PreferredShippingRateOption =
      formValues.preferredShippingRateOption || null;
    this.scheduledOrder.EnableAutoShippingRate =
      formValues.enableAutoShippingRate!;
    this.scheduledOrder.PaymentMethodId =
      formValues.paymentMethodId || undefined;
    this.scheduledOrder.PaymentMethod = formValues.paymentMethod || undefined;
    this.scheduledOrder.Name = formValues.name!;
    this.scheduledOrder.Note = formValues.note!;
    this.scheduledOrder.NextOccurrenceOffset = formValues.nextOccurrenceOffset!;
    this.scheduledOrder.CurrencyIso = formValues.currencyIso!;
    this.scheduledOrder.UtcOffset = formValues.utcOffset!;
    this.scheduledOrder.DisplaySalePrice = formValues.displaySalePrice!;

    // CRITICAL: Get ShippingRateOptions from form component (not in reactive form, stored as component state)
    if (this.formComponent) {
      this.scheduledOrder.ShippingRateOptions =
        this.formComponent.shippingRateOptions || [];
    }
  }

  /**
   * Update the scheduled order
   * Simplified to match old QMC update() method (lines 605-665)
   * Applies form values directly to scheduledOrder, refreshes totals, then calls API
   */
  update(): void {
    // Prevent multiple clicks (matches old QMC)
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    // Full validation - check FORM values instead of scheduledOrder
    // because form values haven't been applied to scheduledOrder yet
    const formValues = this.formGroup.getRawValue();

    // Customer is required
    if (!this.scheduledOrder || !formValues.customerId) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Customer is required",
        life: 5000,
      });
      this.isSaving = false;
      return;
    }

    // At least one product is required
    if (
      !formValues.scheduledOrderItems ||
      formValues.scheduledOrderItems.length === 0
    ) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "At least one product is required",
        life: 5000,
      });
      this.isSaving = false;
      return;
    }

    // Next occurrence date is required
    if (!formValues.nextOccurrenceUtc) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Next Occurrence Date is required",
        life: 5000,
      });
      this.isSaving = false;
      return;
    }

    // Payment method is required - either existing OR valid new payment method
    if (
      !formValues.paymentMethodId &&
      !this.formComponent.isNewPaymentMethodValid
    ) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Payment method is required",
        life: 5000,
      });
      this.isSaving = false;
      return;
    }

    // Shipping address is required (country and city at minimum)
    if (!formValues.shippingCountry || !formValues.shippingCity) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Shipping address (country and city) is required",
        life: 5000,
      });
      this.isSaving = false;
      return;
    }

    // Step 1: Refresh totals first (matches old QMC line 607)
    this.formComponent.refreshTotals();

    // Step 2: Subscribe to totals completion (matches old QMC lines 608-662)
    this.formComponent
      .subscribeTotalsComplete()
      .pipe(
        takeUntil(this.destroy$),
        switchMap((result) => {
          if (result !== true) {
            this.isSaving = false;
            return of(null);
          }

          // Capture whether we're creating a new payment method before applying values
          const wasCreatingNewPaymentMethod =
            !this.formGroup.getRawValue().paymentMethodId;

          // Step 3: Apply form values to scheduledOrder
          this.applyFormValuesToOrder();

          // Step 4: Set payment method from newPaymentMethod if no payment method selected (matches old QMC lines 613-615)
          if (
            this.scheduledOrder!.PaymentMethodId == null &&
            this.newPaymentMethod.Type != null
          ) {
            this.scheduledOrder!.PaymentMethod = this.newPaymentMethod;
          }

          // Step 5: Handle Nextime next occurrence alignment (matches old QMC lines 617-626)
          if (
            this.nextimeShouldAlignNextOrderDate &&
            this.scheduledOrder!.NextOccurrenceUtc &&
            this.site
          ) {
            const nextOccurrenceDate = new Date(
              this.scheduledOrder!.NextOccurrenceUtc,
            );

            if (this.site.SupportsProcessingWindow) {
              // For V3 sites with processing window
              const hours = nextOccurrenceDate
                .getHours()
                .toString()
                .padStart(2, "0");
              const minutes = nextOccurrenceDate
                .getMinutes()
                .toString()
                .padStart(2, "0");
              const timeString = `${hours}:${minutes}`;

              const utcDateString =
                this.timezoneHelper.getUtcDateFromTimezoneOffset(
                  nextOccurrenceDate,
                  timeString,
                  this.site.UtcOffset || 0,
                );

              if (utcDateString) {
                this.scheduledOrder!.NextOccurrenceUtc = utcDateString;
              }
            } else {
              // For non-V3 sites
              this.scheduledOrder!.NextOccurrenceUtc = this.timezoneHelper
                .getDateFromUtcOffsetForSave(
                  nextOccurrenceDate,
                  this.site.UtcOffset || 0,
                )
                .toISOString();
            }
          }

          // Step 6: Clear SiteShippingAddressId if using custom address (matches old QMC lines 628-630)
          if (this.selectedCustomerShippingTabIndex === 0) {
            this.scheduledOrder!.SiteShippingAddressId = undefined;
          }

          // Step 7: Set PreValidateSynchronously = true (matches old QMC line 632)
          this.scheduledOrder!.PreValidateSynchronously = true;

          // Step 8: Clean up coupons string (matches old QMC line 634)
          if (this.scheduledOrder!.Coupons) {
            this.scheduledOrder!.Coupons = this.scheduledOrder!.Coupons.replace(
              /\s/g,
              "",
            );
          }

          // Step 9: Call API directly (matches old QMC line 638)
          return this.scheduledOrderService
            .update(this.siteId, this.scheduledOrder!, this.getAccessToken())
            .pipe(
              tap((updated) => {
                // Step 10: Reset totals observer for next save (matches old QMC line 641)
                this.formComponent.resetTotalsObserver();

                // Step 11: Update local state (matches old QMC lines 644-646)
                if (this.scheduledOrder && updated) {
                  this.scheduledOrder.Metadata = updated.Metadata;
                  this.scheduledOrder.ValidationResult =
                    updated.ValidationResult;
                  this.scheduledOrder.ShippingRateOptions =
                    updated.ShippingRateOptions;
                }

                // Step 12: Refresh validation after save (matches old QMC lines 647-653)
                void this.refreshValidation();

                // Step 13: Refresh totals after save (matches old QMC line 654)
                this.formComponent.refreshTotals();

                // Step 14: Check for coupon validation errors (matches old QMC lines 642-643)
                const couponError = this.getCouponsValidationError(updated);
                if (couponError) {
                  this.messageService.add({
                    severity: "warn",
                    summary: "Coupon Validation",
                    detail: couponError,
                    life: 5000,
                  });
                }

                // Step 15: Restore shipping settings (matches old QMC line 655)
                this.restoreShippingRatesSettingsIfNeeded();

                // Step 16: If a new payment method was created, reload the dropdown and select it
                if (wasCreatingNewPaymentMethod && updated?.PaymentMethodId) {
                  this.scheduledOrder!.PaymentMethodId =
                    updated.PaymentMethodId;
                  this.formComponent.refreshPaymentMethodSelection(
                    updated.PaymentMethodId,
                  );
                }

                this.isSaving = false;
              }),
              catchError((error) => {
                console.error("Error updating scheduled order:", error);
                const errorMessage =
                  error?.message || "Failed to update scheduled order";
                this.messageService.add({
                  severity: "error",
                  summary: "Update Failed",
                  detail: errorMessage,
                  life: 5000,
                });
                this.isSaving = false;
                return of(null);
              }),
            );
        }),
      )
      .subscribe();
  }

  /**
   * Refresh validation result after update or when totals change
   * Ensures ErrorItems and IsInRepeatTimeWindow have correct types
   * Called from refreshTotals flow (matches old QMC lines 482-490)
   */
  async refreshValidation(): Promise<void> {
    if (!this.scheduledOrder) return;

    try {
      const validation = await firstValueFrom(
        this.validationService.updateValidationResult(
          this.siteId,
          this.scheduledOrder, // Pass full order object (matches old QMC)
          this.getAccessToken(),
        ),
      );
      // Ensure ErrorItems is always an array and map to correct interface
      this.scheduledOrder.ValidationResult = {
        ...validation,
        IsInRepeatTimeWindow: validation.IsInRepeatTimeWindow ?? false, // Ensure boolean, not undefined
        ErrorItems: (validation.ErrorItems ?? []).map((item) => ({
          ...item,
          PreProcessingValidationResultCode: 0, // Add missing property with default value
        })),
      };
      this.showValidationIndicator = true;
    } catch (error) {
      // Not critical if validation refresh fails
      console.error("Validation refresh error:", error);
    }
  }

  /**
   * Get coupon validation error message by comparing input coupons vs server-accepted coupons
   * Matches old QMC lines 667-689
   * @param savedOrder The order returned from the save API call
   * @returns Error message if coupons were rejected, null otherwise
   */
  private getCouponsValidationError(savedOrder: ScheduledOrder): string | null {
    if (!this.scheduledOrder?.Coupons || !savedOrder.Coupons) {
      return null;
    }

    // Clean whitespace from saved order coupons (matches old QMC line 668)
    const scheduledOrderCoupons = savedOrder.Coupons.replace(/\s/g, "");

    let invalidCoupons: string;
    if (scheduledOrderCoupons) {
      // Compare input coupons vs accepted coupons (matches old QMC lines 673-678)
      const couponCodesThatWhereInput = this.scheduledOrder.Coupons.split(",");
      const couponCodesThatWhereAccepted = scheduledOrderCoupons.split(",");
      const couponCodesThatWhereNotAccepted = couponCodesThatWhereInput.filter(
        (item) => couponCodesThatWhereAccepted.indexOf(item) === -1,
      );
      invalidCoupons = couponCodesThatWhereNotAccepted.join(",");
    } else {
      // All coupons were rejected (matches old QMC line 680)
      invalidCoupons = this.scheduledOrder.Coupons;
    }

    if (invalidCoupons) {
      // Return error message (matches old QMC line 684)
      return `The following coupons could not be applied to the scheduled order (non existent or invalid): ${invalidCoupons}`;
    }

    return null;
  }

  /**
   * Restore shipping rate settings if needed after save
   * Matches old QMC lines 509-513
   * If the order has no preferred shipping rate, set it to the default
   */
  private restoreShippingRatesSettingsIfNeeded(): void {
    if (!this.scheduledOrder?.PreferredShippingRateOption) {
      this.setDefaultShippingRate();
    }
  }

  /**
   * Set the default shipping rate from ShippingRateOptions
   * Matches old QMC lines 515-524
   * Finds the shipping option marked as IsDefault and sets it as preferred
   */
  private setDefaultShippingRate(): void {
    if (!this.scheduledOrder?.ShippingRateOptions) {
      return;
    }

    const defaultShippingRate = this.getDefaultShippingRate();
    if (defaultShippingRate) {
      this.scheduledOrder.PreferredShippingRateOption =
        defaultShippingRate.OptionValue;
      this.scheduledOrder.FreeShipping = defaultShippingRate;
    }
  }

  /**
   * Get the default shipping rate from ShippingRateOptions
   * Matches old QMC lines 526-528
   * @returns The shipping option marked as IsDefault, or null if none found
   */
  private getDefaultShippingRate(): ScheduledOrderShippingRateOption | null {
    return (
      this.scheduledOrder?.ShippingRateOptions?.find((s) => s.IsDefault) ?? null
    );
  }

  /**
   * Handle quick action click from the quick actions component
   */
  onQuickAction(event: { action: string; order: ScheduledOrder }): void {
    const action = event.action;

    switch (action) {
      case "pause":
      case "activate":
        this.togglePauseResume();
        break;
      case "processNow":
        this.processNow();
        break;
      case "retry":
        this.retryScheduledOrder();
        break;
      case "edit":
        // Already on edit page, do nothing
        break;
      case "reschedule":
        this.openRescheduleDialog();
        break;
      case "delete":
        this.deleteScheduledOrder();
        break;
      default:
        console.warn(`Unknown quick action: ${action}`);
    }
  }

  /**
   * Process order now (with pre-validation and repeat window check)
   * Streamlined flow: UpdatePreValidationResult -> Retry API -> Refresh order
   */
  processNow(): void {
    if (!this.scheduledOrder || !this.site) return;

    const accessToken = this.getAccessToken();
    if (!accessToken) return;

    this.isProcessing = true;

    // Step 1: Call UpdatePreValidationResult (persists to DB)
    this.qpilotService
      .updateScheduledOrderPreValidationResult(
        this.siteId,
        this.scheduledOrder.Id,
        accessToken,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (validationResult) => {
          if (!validationResult.Succeeded) {
            // Validation failed - show validation dialog
            this.isProcessing = false;
            const orderForDialog = {
              ...this.scheduledOrder!,
              ValidationChecks: validationResult,
            };

            this.dialogService.open(ValidationChecksDialogComponent, {
              header: `Validation Checks - Order #${this.scheduledOrder!.Id}`,
              width: "700px",
              modal: true,
              closable: true,
              closeOnEscape: true,
              dismissableMask: false,
              breakpoints: {
                "960px": "90vw",
                "640px": "95vw",
              },
              data: {
                scheduledOrder: orderForDialog,
                site: this.site,
                dontPersistPreValidationRefresh: false,
                accessToken: this.getAccessToken(), // Pass access token for embedded mode
              },
            });
            return;
          }

          // Validation passed - check repeat time window
          if (
            validationResult.IsInRepeatTimeWindow &&
            this.scheduledOrder!.LastOccurrenceUtc != null
          ) {
            // In repeat time window - show confirmation dialog
            this.confirmationService.confirm({
              message: `This order was processed recently on ${new Date(this.scheduledOrder!.LastOccurrenceUtc).toLocaleString()}. Are you sure you want to process it again?`,
              header: "Confirm",
              icon: "pi pi-exclamation-triangle",
              acceptLabel: "Yes, process it again",
              rejectLabel: "Cancel",
              accept: () => {
                this.executeProcessNow(accessToken);
              },
              reject: () => {
                this.isProcessing = false;
              },
            });
          } else {
            // Not in repeat window - proceed directly
            this.executeProcessNow(accessToken);
          }
        },
        error: (error) => {
          console.error("Pre-validation failed:", error);
          this.isProcessing = false;
          this.messageService.add({
            severity: "error",
            summary: "Validation Error",
            detail: "Failed to validate scheduled order. Please try again.",
            life: 5000,
          });
        },
      });
  }

  /**
   * Execute process now - call retry API and refresh order
   */
  private executeProcessNow(accessToken: QPilotAccessToken): void {
    // Step 2: Call retry API directly (no additional validation needed)
    this.qpilotService
      .retryScheduledOrder(this.siteId, this.scheduledOrderId, accessToken)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => {
          // Step 3: Reload the order after successful retry to refresh status and menu
          return this.scheduledOrderService.getById(
            this.scheduledOrderId,
            this.getAccessToken(),
          );
        }),
      )
      .subscribe({
        next: (refreshedOrder) => {
          // Update the order with fresh data
          this.scheduledOrder = refreshedOrder;

          // Rebuild the action menu with new status
          this.buildActionMenu();

          this.messageService.add({
            severity: "success",
            summary: "Processing Started",
            detail: "Scheduled Order has been queued for processing",
            life: 3000,
          });

          this.isProcessing = false;
        },
        error: (error) => {
          console.error("Error processing order:", error);
          this.isProcessing = false;
          this.messageService.add({
            severity: "error",
            summary: "Processing Failed",
            detail: "Failed to process scheduled order. Please try again.",
            life: 5000,
          });
        },
      });
  }

  /**
   * Navigate back to list with dual mode support
   * Emits custom event in embedded mode, uses Angular Router in standard mode
   */
  private navigateToList(orderId?: number): void {
    if (this.embeddedMode) {
      // Emit event to signal completion
      const event = new CustomEvent("qmc-order-saved", {
        detail: {
          component: "scheduled-order",
          action: "list",
          orderId: orderId,
          siteId: this.siteId,
        },
        bubbles: true,
        composed: true, // Crosses shadow DOM boundary
      });
      this.elementRef.nativeElement.dispatchEvent(event);
    } else {
      // Use standard routing
      void this.router.navigate([
        "/widgets",
        "dashboard",
        this.siteId,
        "scheduled-orders",
      ]);
    }
  }

  /**
   * Cancel and navigate back to list
   */
  cancel(): void {
    this.navigateToList();
  }

  // Note: canSubmit validation is now handled by the form component
  // It checks actual form values instead of the scheduledOrder model

  /**
   * Delete the scheduled order
   * Refactored to use pure observable pattern (Task 7.2)
   */
  deleteOrder(): void {
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete this scheduled order? This action cannot be undone.",
      header: "Confirm Delete",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        // Use pure observable pattern instead of async callback
        this.scheduledOrderService
          .delete(this.siteId, this.scheduledOrderId)
          .pipe(
            takeUntil(this.destroy$),
            tap(() => {
              // Navigate back to list after successful delete (handles both embedded and standard modes)
              this.navigateToList();
            }),
            catchError((error) => {
              console.error("Error deleting scheduled order:", error);
              // Error message shown by ScheduledOrderService
              return of(null);
            }),
          )
          .subscribe();
      },
    });
  }

  /**
   * Pause or Resume the scheduled order based on current status
   * Refactored to use pure observable pattern (Task 7.2)
   */
  togglePauseResume(): void {
    const isPaused = this.scheduledOrder?.Status === "Paused";
    const action = isPaused ? "resume" : "pause";
    const actionText = isPaused ? "Resume" : "Pause";

    this.confirmationService.confirm({
      message: `Are you sure you want to ${action} this scheduled order?`,
      header: `Confirm ${actionText}`,
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        // Use pure observable pattern instead of async callback
        const action$ = isPaused
          ? this.scheduledOrderService.resume(
              this.siteId,
              this.scheduledOrderId,
              this.getAccessToken(),
            )
          : this.scheduledOrderService.pause(
              this.siteId,
              this.scheduledOrderId,
              this.getAccessToken(),
            );

        action$
          .pipe(
            takeUntil(this.destroy$),
            tap(() => {
              // Reload order to get updated status
              void this.loadScheduledOrder();
            }),
            catchError((error) => {
              console.error(`Error ${action}ing scheduled order:`, error);
              // Error message shown by ScheduledOrderService
              return of(null);
            }),
          )
          .subscribe();
      },
    });
  }

  /**
   * Clone/duplicate the scheduled order
   * Refactored to use pure observable pattern (Task 7.2)
   */
  cloneOrder(): void {
    this.confirmationService.confirm({
      message:
        "Are you sure you want to clone this scheduled order? A new order will be created with the same settings.",
      header: "Confirm Clone",
      icon: "pi pi-question-circle",
      accept: () => {
        // Use pure observable pattern instead of async callback
        this.scheduledOrderService
          .clone(this.siteId, this.scheduledOrderId)
          .pipe(
            takeUntil(this.destroy$),
            tap((cloned) => {
              // Navigate to edit the newly cloned order
              void this.router.navigate([
                "/widgets",
                "dashboard",
                this.siteId,
                "scheduled-orders",
                cloned.Id,
                "edit",
              ]);
            }),
            catchError((error) => {
              console.error("Error cloning scheduled order:", error);
              // Error message shown by ScheduledOrderService
              return of(null);
            }),
          )
          .subscribe();
      },
    });
  }

  /**
   * Open processing history dialog
   */
  openHistoryDialog(): void {
    if (!this.site || !this.scheduledOrder) return;

    this.dialogService.open(ScheduledOrderHistoryDialogComponent, {
      header: "Event Logs",
      width: "90vw",
      modal: true,
      closable: true,
      closeOnEscape: true,
      maximizable: true,
      breakpoints: {
        "960px": "90vw",
        "640px": "95vw",
      },
      style: {
        "max-height": "80vh",
      },
      data: {
        scheduledOrder: this.scheduledOrder,
        scheduledOrderId: this.scheduledOrder.Id,
        site: this.site,
        accessToken: this.getAccessToken(), // Pass access token for embedded mode
      },
    });
  }

  /**
   * Open processing cycles dialog
   */
  openCyclesDialog(): void {
    if (!this.site || !this.scheduledOrder) return;

    const isMobile = window.innerWidth <= 768;
    const dialogRef = this.dialogService.open(
      ScheduledOrderCyclesDialogComponent,
      {
        header: "Processing Cycles History",
        width: isMobile ? "95vw" : "80vw",
        height: isMobile ? "85vh" : "70vh",
        modal: true,
        closable: true,
        closeOnEscape: true,
        maximizable: true,
        dismissableMask: true,
        breakpoints: {
          "960px": "90vw",
          "640px": "95vw",
        },
        contentStyle: {
          overflow: "auto",
          padding: isMobile ? "0.75rem" : "1rem",
        },
        style: {
          "max-width": "1200px",
        },
        data: {
          scheduledOrder: this.scheduledOrder,
          scheduledOrderId: this.scheduledOrder.Id,
          siteId: this.siteId,
          site: this.site,
          embeddedMode: this.embeddedMode, // Pass embedded mode to dialog
          accessToken: this.getAccessToken(), // Pass access token for embedded mode
        },
      },
    );

    // Listen for navigation events from dialog (for embedded mode)
    if (dialogRef.onClose) {
      dialogRef.onClose.subscribe((result: any) => {
        if (
          result?.action === "navigate-to-cycle" &&
          result.processingCycleId
        ) {
          this.goToProcessingCycleView(result.processingCycleId);
        }
      });
    }
  }

  /**
   * Open reschedule dialog to change next occurrence date
   */
  openRescheduleDialog(): void {
    if (!this.scheduledOrder || !this.site) return;

    const isMobile = window.innerWidth < 768;

    const dialogRef = this.dialogService.open(RescheduleDialogComponent, {
      header: `Reschedule Order #${this.scheduledOrder.Id}`,
      width: isMobile ? "95vw" : "450px",
      modal: true,
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      focusOnShow: false,
      styleClass: "reschedule-dialog-container",
      breakpoints: { "768px": "95vw" },
      data: {
        orderId: this.scheduledOrder.Id,
        siteId: this.siteId,
        currentNextOccurrenceUtc: this.scheduledOrder.NextOccurrenceUtc,
        utcOffset: this.scheduledOrder.UtcOffset,
        frequency: this.scheduledOrder.Frequency,
        frequencyType: this.scheduledOrder.FrequencyType,
        resumeAfter: this.scheduledOrder.Status === "Paused",
        inputToken: this.getAccessToken(),
      },
    });

    dialogRef.onClose.subscribe(
      (result: RescheduleDialogResult | undefined) => {
        if (result?.success) {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Next order date updated successfully",
          });
          // Refresh the order data
          void this.loadScheduledOrder();
        }
      },
    );
  }

  /**
   * Check if Pause/Resume button should be shown
   */
  canPauseOrResume(): boolean {
    const status = this.scheduledOrder?.Status;
    return (
      status === "Active" ||
      status === "Paused" ||
      status === "Failed" ||
      status === "Queued"
    );
  }

  /**
   * Get label for Pause/Resume button
   */
  getPauseResumeLabel(): string {
    return this.scheduledOrder?.Status === "Paused" ? "Resume" : "Pause";
  }

  /**
   * Get icon for Pause/Resume button
   */
  getPauseResumeIcon(): string {
    return this.scheduledOrder?.Status === "Paused"
      ? "pi pi-play"
      : "pi pi-pause";
  }

  /**
   * Check if Delete button should be shown
   */
  canDelete(): boolean {
    const status = this.scheduledOrder?.Status;
    return status !== "Processing" && status !== "Deleted";
  }

  /**
   * Navigate to processing cycle details view
   */
  goToProcessingCycleView(processingCycleId: number): void {
    if (this.embeddedMode) {
      // Embedded mode: emit custom event for parent to handle navigation
      const event = new CustomEvent("qmc-navigate-to-cycle", {
        detail: {
          component: "scheduled-order-edit",
          targetComponent: "processing-cycle-view",
          siteId: this.siteId,
          scheduledOrderId: this.scheduledOrderId,
          processingCycleId: processingCycleId,
        },
        bubbles: true,
        composed: true,
      });
      this.elementRef.nativeElement.dispatchEvent(event);
    } else {
      // Standard mode: use router navigation
      const navigationUrl = `/widgets/dashboard/${this.siteId}/scheduled-orders/${this.scheduledOrderId}/edit/processing-cycles/${processingCycleId}`;
      void this.router.navigateByUrl(navigationUrl);
    }
  }

  /**
   * Open processing logs dialog for a specific cycle
   * Matches old QMC loadLogs method (lines 1361-1371)
   * Uses existing ProcessingCycleLogsDialogComponent
   */
  loadLogs(cycle: any): void {
    this.dialogService.open(ProcessingCycleLogsDialogComponent, {
      header: `Processing Cycle ${cycle.ProcessingId} Logs`,
      width: "90vw",
      height: "80vh",
      modal: true,
      closable: true,
      closeOnEscape: true,
      dismissableMask: false,
      breakpoints: {
        "960px": "90vw",
        "640px": "98vw",
      },
      maximizable: true,
      data: {
        scheduledOrderId: cycle.ScheduledOrderId,
        siteId: this.siteId,
        processingCycleId: cycle.Id,
        processingCycle: cycle,
        accessToken: this.getAccessToken(), // Pass access token for embedded mode
      },
    });
  }

  /**
   * Build action menu items based on current order state
   */
  private buildActionMenu(): void {
    if (!this.scheduledOrder) {
      this.actionMenuItems = [];
      return;
    }

    const order = this.scheduledOrder;
    const menuItems: MenuItem[] = [];

    // View Event Logs
    menuItems.push({
      label: "View Event Logs",
      icon: "pi pi-info-circle",
      command: () => this.loadHistory(),
    });

    // View Last Cycle Details
    if (order.LastProcessingCycle && order.Status !== "Processing") {
      menuItems.push({
        label: "View Last Cycle Details",
        icon: "pi pi-search",
        command: () =>
          this.goToProcessingCycleView(order.LastProcessingCycle!.Id),
      });
    }

    // View Cycles History
    menuItems.push({
      label: "View Cycles History",
      icon: "pi pi-history",
      command: () => this.loadCycles(),
    });

    // Build action items array first to check if we need a separator
    const actionItems: MenuItem[] = [];

    // Activate (Failed, Paused, Deleted, or Queued orders)
    if (
      order.Status === "Failed" ||
      order.Status === "Paused" ||
      order.Status === "Deleted" ||
      order.Status === "Queued"
    ) {
      actionItems.push({
        label: "Activate",
        icon: "pi pi-play",
        command: () => this.activateScheduledOrder(),
      });
    }

    // Pause (Active orders only)
    if (order.Status === "Active") {
      actionItems.push({
        label: "Pause",
        icon: "pi pi-pause",
        command: () => this.pauseScheduledOrder(),
      });
    }

    // Process Now (Active, Paused, or Failed orders)
    if (
      !this.isProcessing &&
      (order.Status === "Active" ||
        order.Status === "Paused" ||
        order.Status === "Failed")
    ) {
      actionItems.push({
        label: "Process Now",
        icon: "pi pi-refresh",
        command: () => this.processNow(),
      });
    }

    // Restart Processing (Retry)
    if (!this.isProcessing && order.Status === "Failed") {
      actionItems.push({
        label: "Restart Processing",
        icon: "pi pi-refresh",
        command: () => this.retryScheduledOrder(),
      });
    }

    // Retry Update Order
    if (order.Status === "Failed" && order.ProcessingErrorCode === 3001) {
      actionItems.push({
        label: "Retry Update Order",
        icon: "pi pi-refresh",
        command: () => this.retryUpdateOrder(),
      });
    }

    // Reschedule (Active, Failed, or Paused orders)
    if (
      order.Status === "Active" ||
      order.Status === "Failed" ||
      order.Status === "Paused"
    ) {
      actionItems.push({
        label: "Reschedule",
        icon: "pi pi-calendar",
        command: () => this.openRescheduleDialog(),
      });
    }

    // Only add separator and action items if there are any
    if (actionItems.length > 0) {
      menuItems.push({ separator: true });
      menuItems.push(...actionItems);
    }

    // Cancel/Delete (Active, Failed, Paused only - not Processing, Deleted, or Queued)
    if (
      order.Status === "Active" ||
      order.Status === "Failed" ||
      order.Status === "Paused"
    ) {
      menuItems.push({ separator: true });
      menuItems.push({
        label: "Cancel/Delete",
        icon: "pi pi-times",
        command: () => this.deleteScheduledOrder(),
      });
    }

    this.actionMenuItems = menuItems;
  }

  /**
   * Navigate back to scheduled orders list
   * Uses navigateToList() for dual-mode support (router vs events)
   */
  goBackToList(): void {
    this.navigateToList();
  }

  /**
   * Get severity for status tag
   */
  getStatusSeverity(
    status?: string,
  ): "success" | "danger" | "warning" | "info" {
    switch (status) {
      case "Active":
        return "success";
      case "Failed":
        return "danger";
      case "Paused":
        return "warning";
      default:
        return "info";
    }
  }

  /**
   * Load event logs (history) for the scheduled order
   */
  loadHistory(): void {
    if (!this.scheduledOrder) return;

    this.dialogService.open(ScheduledOrderHistoryDialogComponent, {
      header: `Scheduled Order #${this.scheduledOrder.Id} - Event Logs`,
      width: "90vw",
      modal: true,
      closable: true,
      closeOnEscape: true,
      maximizable: true,
      breakpoints: {
        "960px": "90vw",
        "640px": "95vw",
      },
      style: {
        "max-height": "80vh",
      },
      data: {
        scheduledOrderId: this.scheduledOrder.Id,
        accessToken: this.getAccessToken(), // Pass access token for embedded mode
      },
    });
  }

  /**
   * Load processing cycles for the scheduled order
   */
  loadCycles(): void {
    if (!this.scheduledOrder) return;

    const isMobile = window.innerWidth <= 768;
    const dialogRef = this.dialogService.open(
      ScheduledOrderCyclesDialogComponent,
      {
        header: `Scheduled Order #${this.scheduledOrder.Id} - Processing Cycles`,
        width: isMobile ? "95vw" : "80vw",
        height: isMobile ? "85vh" : "70vh",
        modal: true,
        closable: true,
        closeOnEscape: true,
        maximizable: true,
        dismissableMask: true,
        breakpoints: {
          "960px": "90vw",
          "640px": "95vw",
        },
        contentStyle: {
          overflow: "auto",
          padding: isMobile ? "0.75rem" : "1rem",
        },
        style: {
          "max-width": "1200px",
        },
        data: {
          scheduledOrderId: this.scheduledOrder.Id,
          siteId: this.siteId,
          embeddedMode: this.embeddedMode, // Pass embedded mode to dialog
          accessToken: this.getAccessToken(), // Pass access token for embedded mode
        },
      },
    );

    // Listen for navigation events from dialog (for embedded mode)
    if (dialogRef.onClose) {
      dialogRef.onClose.subscribe((result: any) => {
        if (
          result?.action === "navigate-to-cycle" &&
          result.processingCycleId
        ) {
          this.goToProcessingCycleView(result.processingCycleId);
        }
      });
    }
  }

  /**
   * Activate a failed or paused scheduled order
   * Matches old QMC lines 1333-1348 - uses observable pattern
   */
  activateScheduledOrder(): void {
    if (!this.scheduledOrder) return;

    this.confirmationService.confirm({
      message: `Are you sure you want to activate Scheduled Order #${this.scheduledOrder.Id}?`,
      header: "Activate Scheduled Order",
      icon: "pi pi-play",
      accept: () => {
        this.isProcessing = true;

        // Call activate API and then reload order to refresh status and menu
        this.qpilotService
          .activateScheduledOrder(
            this.siteId,
            this.scheduledOrderId,
            this.getAccessToken()!,
          )
          .pipe(
            takeUntil(this.destroy$),
            switchMap(() => {
              // Reload the order after successful activation to refresh status and menu
              return this.scheduledOrderService.getById(
                this.scheduledOrderId,
                this.getAccessToken(),
              );
            }),
          )
          .subscribe({
            next: (refreshedOrder) => {
              // Update the order with fresh data
              this.scheduledOrder = refreshedOrder;

              // Rebuild the action menu with new status
              this.buildActionMenu();

              // Show success message
              this.messageService.add({
                severity: "success",
                summary: "Scheduled Order Activated",
                detail: "Scheduled order activated successfully",
                life: 3000,
              });

              this.isProcessing = false;
            },
            error: (error) => {
              console.error("Error activating scheduled order:", error);
              this.isProcessing = false;
              // Error message handled by interceptor
            },
          });
      },
    });
  }

  /**
   * Pause an active scheduled order
   */
  pauseScheduledOrder(): void {
    if (!this.scheduledOrder) return;

    this.confirmationService.confirm({
      message: `Are you sure you want to pause Scheduled Order #${this.scheduledOrder.Id}?`,
      header: "Pause Scheduled Order",
      icon: "pi pi-pause",
      acceptButtonStyleClass: "p-button-warning",
      acceptLabel: "Yes, pause it",
      rejectLabel: "Cancel",
      accept: () => {
        this.isProcessing = true;

        this.qpilotService
          .pauseScheduledOrder(
            this.siteId,
            this.scheduledOrderId,
            this.getAccessToken()!,
          )
          .pipe(
            takeUntil(this.destroy$),
            switchMap(() => {
              // Reload the order after successful pause to refresh status and menu
              return this.scheduledOrderService.getById(
                this.scheduledOrderId,
                this.getAccessToken(),
              );
            }),
          )
          .subscribe({
            next: (refreshedOrder) => {
              // Update the order with fresh data
              this.scheduledOrder = refreshedOrder;

              // Rebuild the action menu with new status
              this.buildActionMenu();

              // Show success message
              this.messageService.add({
                severity: "success",
                summary: "Scheduled Order Paused",
                detail: "Scheduled order paused successfully",
                life: 3000,
              });

              this.isProcessing = false;
            },
            error: (error) => {
              console.error("Error pausing scheduled order:", error);
              this.isProcessing = false;
              // Error message handled by interceptor
            },
          });
      },
    });
  }

  /**
   * Retry a failed scheduled order
   * Matches old QMC lines 1234-1264 with pre-validation - uses observable pattern
   */
  async retryScheduledOrder(): Promise<void> {
    if (!this.scheduledOrder) return;

    this.isProcessing = true;

    try {
      // Step 1: Pre-validate the order (matches old QMC line 1238)
      // Note: Using await here is acceptable as validation service returns observable
      const validation = await firstValueFrom(
        this.validationService.validate(
          this.siteId,
          this.scheduledOrder,
          this.getAccessToken(),
        ),
      );

      if (validation.Succeeded) {
        // Validation passed - retry the order
        this.confirmationService.confirm({
          message: `Are you sure you want to restart processing for Scheduled Order #${this.scheduledOrder.Id}?`,
          header: "Restart Processing",
          icon: "pi pi-refresh",
          accept: () => {
            // Call retry API and then reload order to refresh status and menu
            this.qpilotService
              .retryScheduledOrder(
                this.siteId,
                this.scheduledOrderId,
                this.getAccessToken()!,
              )
              .pipe(
                takeUntil(this.destroy$),
                switchMap(() => {
                  // Reload the order after successful retry to refresh status and menu
                  return this.scheduledOrderService.getById(
                    this.scheduledOrderId,
                    this.getAccessToken(),
                  );
                }),
              )
              .subscribe({
                next: (refreshedOrder) => {
                  // Update the order with fresh data
                  this.scheduledOrder = refreshedOrder;

                  // Rebuild the action menu with new status
                  this.buildActionMenu();

                  // Show success message
                  this.messageService.add({
                    severity: "success",
                    summary: "Processing Restarted",
                    detail: "Scheduled Order has restarted processing",
                    life: 3000,
                  });

                  this.isProcessing = false;
                },
                error: (error) => {
                  console.error("Error retrying scheduled order:", error);
                  this.isProcessing = false;
                  // Error message handled by interceptor
                },
              });
          },
          reject: () => {
            this.isProcessing = false;
          },
        });
      } else {
        // Validation failed - show validation issues (matches old QMC line 1258)
        this.messageService.add({
          severity: "warn",
          summary: "Validation Failed",
          detail: "Please fix validation issues before retrying",
          life: 5000,
        });
        this.isProcessing = false;
      }
    } catch (error) {
      console.error("Pre-validation error:", error);
      this.isProcessing = false;
    }
  }

  /**
   * Retry update order (for error code 3001)
   * Matches old QMC lines 1316-1331 - uses observable pattern
   */
  retryUpdateOrder(): void {
    if (!this.scheduledOrder) return;

    this.confirmationService.confirm({
      message: `Are you sure you want to retry updating the order for Scheduled Order #${this.scheduledOrder.Id}?`,
      header: "Retry Update Order",
      icon: "pi pi-refresh",
      accept: () => {
        // Call the retry update API (matches old QMC line 1317)
        this.qpilotService
          .retryUpdateOrder(
            this.siteId,
            this.scheduledOrderId,
            this.getAccessToken()!,
            true,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response: any) => {
              // Update local status from response (matches old QMC line 1319)
              if (this.scheduledOrder && response) {
                this.scheduledOrder.Status = response.Status;
              }

              // Show success message (matches old QMC line 1320)
              this.messageService.add({
                severity: "success",
                summary: "Update Retry Started",
                detail: "Order Update in progress",
                life: 3000,
              });
            },
            error: (error) => {
              console.error("Error retrying update order:", error);
              // Error message handled by interceptor
            },
          });
      },
    });
  }

  /**
   * Delete the scheduled order
   * Matches old QMC lines 1390-1399
   */
  deleteScheduledOrder(): void {
    if (!this.scheduledOrder) return;

    this.confirmationService.confirm({
      message: `Are you sure you want to delete Scheduled Order #${this.scheduledOrder.Id}? This action cannot be undone.`,
      header: "Delete Scheduled Order",
      icon: "pi pi-exclamation-triangle",
      acceptButtonStyleClass: "p-button-danger",
      accept: () => {
        this.isProcessing = true;

        // Call delete API with observable pattern (matches old QMC line 1393)
        this.scheduledOrderService
          .delete(this.siteId, this.scheduledOrderId)
          .pipe(
            takeUntil(this.destroy$),
            tap(() => {
              this.isProcessing = false;
              // Navigate back to list after successful delete (handles both embedded and standard modes)
              this.navigateToList();
            }),
            catchError((error) => {
              console.error("Error deleting scheduled order:", error);
              this.isProcessing = false;
              // Error message shown by ScheduledOrderService
              return of(null);
            }),
          )
          .subscribe();
      },
    });
  }

  /**
   * Cleanup on component destroy
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.liveDataService.unsubscribe();
  }
}
